import axios from "axios";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useServiceStore } from "@/stores/serviceStore";
import { phoneFormatter } from "@/utils/functions";
import cookies from 'browser-cookies'
import { API_URL } from "@/utils/constans";

export const useRequestsStore = defineStore("request", () => {
	const router = useRouter();
	const storeField = useFieldsStore();
	const storeService = useServiceStore();

	const isClient = typeof window !== 'undefined';	

	const token = ref(null);	
	const sessionToken = ref(null)
	const courtId = ref(null)
	if(isClient) {
		token.value = cookies.get('token');
		sessionToken.value = sessionStorage.getItem('sessionToken');
		courtId.value = sessionStorage.getItem('courtIdToken');
	}

	const setToken = (newToken) => {
        token.value = newToken; 
        cookies.set('token', newToken, {expires: 1}); 
    };
    const removeToken = () => {
        token.value = null; 
        cookies.erase('token');
    };

	const setSessionToken = (newToken) => {
		sessionToken.value = newToken;
		sessionStorage.setItem("sessionToken", newToken);
	};

	const loaderBtn = ref(false);
	const isScreenLoading = ref(true);
	const userData = ref({});
	const payData = ref({});	
	const responseError = ref(null);
	const responseOk = ref(null);
	const listCourts = ref([])
	const listQuipments = ref([])
	const isProductsLoaded = ref(false)
	const courtData = ref({})
	const listCourtDates = computed(() => courtData.value.results)
	const isAuthenticated = computed(() => !!token.value);
	const isNotProduct = computed(() => listCourts.value.length !== 0);

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				removeToken();
				delete axios.defaults.headers.common["Authorization"];
			}
			return Promise.reject(error);
		},
	);

	const setAuthHeader = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const tokenURL = urlParams.get("token");
		if (tokenURL) {
			token.value = tokenURL;
		} else {
			token.value = cookies.get('token');
		}
		if (token.value) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	};

	const authorization = async () => {
		loaderBtn.value = true;
		const parameters = {
			phone_number: phoneFormatter(storeField.fields.phone.title),
		};
		try {
			const { data } = await axios.post(`${API_URL}/api/users/authorization`, parameters);
			setSessionToken(data.session_token);		
			responseError.value = null;
			responseOk.value = true;
			// storeField.updateAuthorization();	
		} catch (error) {
			console.log("error sendAuthorization:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const authorizationConfirm = async () => {
		loaderBtn.value = true;
		const parameters = {
			code: storeField.fields.confirmationCode.title,
			session_token: sessionToken.value,
		};

		try {
			const { data } = await axios.post(`${API_URL}/api/users/authorization/confirm`, parameters);
			setToken(data.access);		
			await userInfo();	
			responseError.value = null;
			responseOk.value = true;
		} catch (error) {
			console.log("error authorizationConfirm:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			storeField.fields.confirmationCode.title = "";
		} finally {
			loaderBtn.value = false;
		}
	};

	const userInfo = async () => {
		try {
			setAuthHeader();
			const { data } = await axios.get(`${API_URL}/api/users/user`);
			userData.value = data;			
		} catch (error) {
			if (error.response && error.response.status === 401) {
				console.warn("Пользователь не авторизован");
				userData.value = null;
			} else {
				console.error("Error getUserInfo", error);
				throw error;
			}
		} finally {
			storeService.hideScreenLoader()
		}
	};
	const userInfoChnage = async () => {
		loaderBtn.value = true;

		const parameters = {
			email: storeField.fields.email.title || userData.value.email,
			first_name: storeField.fields.firstName.title || userData.value.first_name,
			last_name: storeField.fields.lastName.title || userData.value.last_name,
			birthday: storeField.fields.birthday.title || userData.value.birthday,
		};

		try {
			setAuthHeader();
			const { data } = await axios.put(`${API_URL}/api/users/user`, parameters);
			userData.value = data;		
			responseError.value = null;
			responseOk.value = true;	
		} catch (error) {
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			console.error("Error userInfoChnage", error);
		} finally {
			loaderBtn.value = false;
		}
	};
	
	const contactPhoneNumberForFeedback = async () => {
		loaderBtn.value = true;

		const parameters = {
			phone_number: phoneFormatter(storeField.fields.phone.title),
		};
		try {
			const res = await axios.post(`${API_URL}/api/courts/contacts`, parameters);
			responseError.value = "";
			responseOk.value = true;
			
		} catch (error) {
			if(error.response.status === 400 && error.response?.data?.phone_number[0]) {
				responseError.value =  "Укажите корректный номер телефона.";
			} else {
				responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			}
			console.error("Error sendFeedback", error);
		} finally {
			storeField.updateFormContactFeedback();						
			loaderBtn.value = false;
		}
	};

	const getCourts = async () => {
		try {
			const{ data }= await axios.get(`${API_URL}/api/courts`);
			listCourts.value = data.results;
		} catch (error) {
			console.log("error getCourts:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			
		}
	};

	const geteQuipments = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/courts/equipment`);
			listQuipments.value = data.results;
		} catch (error) {
			console.log("error geteQuipments:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			
		}
	};

	const getCourtsSlots = async (court) => {
		loaderBtn.value = true;
		try {
			const params = {
				court_id: court.court_id,
				start_date: court.start_date,
				end_date: court.end_date,
				limit: court.limit,
				offset: court.offset
			};
			const { data } = await axios.get(`${API_URL}/api/courts/slots`, {params});
			courtData.value = data;
			responseError.value = null;
			responseOk.value = true;
		} catch (error) {
			console.log("error getCourtsSlots:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const getPaymentUrl = async (parameters) => {
		
		loaderBtn.value = true;
		try {
			setAuthHeader();
			const { data } = await axios.post(`${API_URL}/api/courts/rent`, parameters );
			payData.value = data;
			responseError.value = null;
			responseOk.value = true;
		} catch (error) {
			console.log("error getPaymentUrl:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	}

	const getInfoCourts = async () => {
		try {
			const{ data }= await axios.get(`${API_URL}/api/courts/info`);
			return data.results.map((item, index) => {
				return {
					...item,
					id: index
				}
			})
				
			
		} catch (error) {
			console.log("error getInfoCourts:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			
		}
	};
	const getRentalInfo = async (id) => {
		try {
			setAuthHeader();
			const{ data }= await axios.get(`${API_URL}/api/courts/rent/${id}`);
			return data;			
		} catch (error) {
			console.log("error getRentalInfo:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			
		}
	};

	const logout = async () => {
		removeToken();
		userData.value = {};
		storeField.updateFiles();
		router.push({ name: "Home" });
	};

	
	return {
		setAuthHeader,
		authorization,
		authorizationConfirm,
		logout,
		userInfo,
		userInfoChnage,
		contactPhoneNumberForFeedback,
		getCourts,
		geteQuipments,
		getCourtsSlots,
		getPaymentUrl,
		getInfoCourts,
		getRentalInfo,

		isAuthenticated,
		loaderBtn,
		isScreenLoading,
		userData,
		responseError,
		responseOk,
		listCourts,
		listQuipments,
		courtData,
		listCourtDates,
		courtId,
		payData,
		isNotProduct,
		isProductsLoaded,
	};
});
